import React from 'react';
import ReactTooltip from 'react-tooltip';
import { useFlags } from 'launchdarkly-react-client-sdk';
import PropTypes from 'prop-types';

import env from '../../../utils/env';
import Collapse from '../Collapse/Collapse';
import styles from './BillingAndShipping.module.css';

const formatCurrency = (price) => `$${price}`;

const BillingAndShipping = ({ shippingAddress, credits }) => {
  const { address1, address2, city, region, code } = shippingAddress;
  const { purchaseCredit, shoppingCredit } = credits;
  const { shoppingCredit: shoppingCreditFF } = useFlags();

  return (
    <>
      <div className={styles.container}>
        <Collapse title="Billing &amp; Shipping Details">
          <div className={styles.rows}>
            <div className={styles.row}>
              <div className={styles.boxContainer}>
                <div className={styles.box}>
                  <h3>Billing Info</h3>
                  <p>Address on file</p>
                </div>
                <div className={`${styles.box} ${styles.card}`}>
                  <h3>Card</h3>
                  <p>Card on file</p>
                </div>
              </div>
              <a
                href={`https://${env.hostname}/my-account`}
                className={styles.button}
              >
                Edit
              </a>
            </div>
            <div className={styles.row}>
              <div className={`${styles.boxContainer} ${styles.credit}`}>
                {shoppingCreditFF && (
                  <div className={styles.box} id="shopping-credit">
                    <h3>Shopping Credit</h3>
                    <p>
                      {formatCurrency(shoppingCredit)}
                      <i
                        className={`fas fa-info-circle ${styles.tooltip}`}
                        data-html
                        data-for="shopping"
                        data-tip='Shopping credit will be applied to your next FabFitFun purchase, excluding membership fees, gift cards, and taxes. <a href="https://legal.fabfitfun.com/#rewards-program-terms" target="_blank" rel="noopener noreferrer">Learn more</a>.'
                      />
                    </p>
                  </div>
                )}
                <div className={styles.box}>
                  <h3>Promotional Credit</h3>
                  <p>
                    {formatCurrency(purchaseCredit)}
                    <i
                      className="fas fa-info-circle"
                      data-tip="Promotional Credit will be applied to your next FabFitFun purchase whether it be your next box, in Add-Ons, or from The Shop!"
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.separator} />
          <div className={`${styles.rows} ${styles.borderBottom}`}>
            <div className={styles.row}>
              <div className={styles.boxContainer}>
                <div className={styles.box}>
                  <h3>Shipping Address</h3>
                  <p>{address1}</p>
                  {address2 && <p>{address2}</p>}
                  <p>{`${city}, ${region} ${code}`}</p>
                </div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
      <ReactTooltip className={styles.tooltip} type="dark" effect="solid" />
      <ReactTooltip
        className={styles.tooltip}
        type="dark"
        effect="solid"
        id="shopping"
        delayHide={1000}
      />
    </>
  );
};

BillingAndShipping.propTypes = {
  shippingAddress: PropTypes.shape({
    address1: PropTypes.string.isRequired,
    address2: PropTypes.string,
    city: PropTypes.string.isRequired,
    region: PropTypes.string.isRequired,
    code: PropTypes.number.isRequired,
  }).isRequired,
  credits: PropTypes.shape({
    purchaseCredit: PropTypes.number.isRequired,
    shoppingCredit: PropTypes.number.isRequired,
  }),
};

BillingAndShipping.defaultProps = {
  credits: {
    shoppingCredit: 0,
    purchaseCredit: 0,
  },
};

export default BillingAndShipping;
